<template>
	<!-- <transition :name="transitionName"> -->
    <div>
      <div class="back-to-ceiling" @click="feedback" :style="customStyle">
        <!-- <i class="el-icon-arrow-up"></i> -->
       <!-- <?xml version="1.0" encoding="UTF-8"?> -->
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 58 (84663) - https://sketch.com -->
            <title>反馈</title>
            <desc>Created with Sketch.</desc>
            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="通知中心_反馈" transform="translate(-1885.000000, -642.000000)">
                    <g id="编组-3" transform="translate(1870.000000, 636.000000)">
                        <g id="编组-4" transform="translate(15.000000, 6.000000)">
                            <path d="M4,3 L15,3 C17.209139,3 19,4.790861 19,7 L19,12.4528853 C19,14.6620243 17.209139,16.4528853 15,16.4528853 L9.46483445,16.4528853 L9.46483445,16.4528853 L5.17712237,18.3702691 C4.67295156,18.5957247 4.08147246,18.3697814 3.85601682,17.8656106 C3.79858477,17.7371793 3.76889881,17.5980748 3.76889881,17.4573871 L3.76889881,16.4528853 L3.76889881,16.4528853 C1.68739347,16.4528853 -1.89178325e-16,14.7654919 0,12.6839865 L0,7 C-2.705415e-16,4.790861 1.790861,3 4,3 Z" id="矩形" fill="#FFC02A"></path>
                            <circle id="椭圆形备份-2" fill="#FFFFFF" cx="9.5" cy="9.5" r="1.5"></circle>
                            <circle id="椭圆形" fill="#FFFFFF" cx="4.5" cy="9.5" r="1.5"></circle>
                            <circle id="椭圆形备份-3" fill="#FFFFFF" cx="14.5" cy="9.5" r="1.5"></circle>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <p>反馈</p>
      </div>
      <el-dialog
        title="意见反馈"
        :visible.sync="visible"
        width="60%">
        <el-form label-width="80px" ref="form" :model="form" :rules="rules">
          <el-form-item label="问题类型" prop="type" required>
            <el-select v-model="form.type" style="max-width: 260px;" placeholder="请选择" filterable clearable>
                <el-option
                    v-for="item in questionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题描述" prop="desc" required>
            <el-input type="textarea" v-model="form.desc" placeholder="请描述下您出现此问题的场景，便于我们更好的为您解决问题哦" maxlength="150" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="图片上传" prop="imgUrl">
            <div class="img-wrap" v-for="(item, index) in imgList" :key="index">
              <div class="delete"><a @click="imgList.splice(index, 1)"><svg-icon icon-class="icon_comic_delete"></svg-icon> 删除</a></div>
              <upload-picture
                :src="item.img"
                :rules="{
                    maxSize: 5
                }"
                tokenType="feedback"
                @upload-success="UploadedSuccess($event, index)">
            </upload-picture>
            </div>
            <upload-picture
                ref="upload"
                v-if="imgList.length < 3 && canUpload"
                :rules="{
                    maxSize: 5
                }"
                :src="form.img"
                tokenType="feedback"
                @upload-success="UploadedSuccess($event)">
            </upload-picture>
            <!-- <div display="inline-block">
              <img v-for="item in imgList" :src="item.img" alt="">
            </div> -->
          </el-form-item>
          <el-form-item label="联系方式" prop="contact">
            <el-input v-model="form.contact" placeholder="方便我们与您联系(电话/QQ/邮箱)"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :append-to-body="true" :visible.sync="successShow" center width="300px" title="感谢您的反馈" @close="successShow = false">
          <div class="success-desc">我们将尽快处理，如有进展我们会在APP-我的消息提醒您</div>
          <div class="success-img-wrap">
            <svg-icon icon-class="collection-success-new" class="svg"></svg-icon>
          </div>
      </el-dialog>
    </div>
	<!-- </transition> -->
</template>

<script>
import { mapGetters } from 'vuex'
import UploadPicture from '@/components/UploadPicture'
export default {
  name: 'Feedback',
  components: {
    UploadPicture
  },
	data() {
		return {
			visible: false,
      interval: null,
      form: {
        type: '',
        desc: '',
        img: '',
        imgUrl: '',
        contact: ''
      },
      imgList: [],
      questionList: [],
      customStyle: {
        right: '15px',
        bottom: '125px',
        width: '50px',
        height: '50px',
        background: '#fff',
        border: '1px solid #F0F2F5',
        zIndex: 1000
      },
      canUpload: true,
      successShow: false,
      rules: {
          type: { required: true, message: '请选择问题类型' },
          desc: { required: true, message: '请填写问题描述' },
      }
    }
  },
  computed: {
		...mapGetters([
      'uid',
      'name'
		])
  },
  watch: {
    visible(val) {
      if (val) {
        this.$util.doSensorsTrack('CreatorCenterPcFeaturesVisit', {
          TriggerPage: 'other',
          FeaturesName: '反馈'
        })
      }
    }
  },
	created() {
    this.getQuestion();
	},
	methods: {
    getQuestion() {
      this.$axios({
        url: '/v1/feedback/question/list',
        params: {
          source: 2
        }
      }).then(res => {
        const data = res.data.fbtypes;
        this.sceneType = data[0].upload_type;
        this.questionList = data[0].scenes.map(item => {
          return {
            value: item.scene_type,
            label: item.scene_name
          }
        })
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$axios({
            url: '/v1/feedbacks',
            params: {
              content: this.form.desc,
              contact: this.form.contact,
              fb_scene_type: this.form.type,
              fb_type: 15,
              image_urls: this.imgList.map(item => item.imgUrl).join(','),
              platform: 3,
              user_id: this.$store.getters.uid || 0
            },
            method: 'post'
          }).then(res => {
            this.visible = false;
            this.successShow = true;
            setTimeout(() => {
              this.successShow = false;
            }, 2000)
          })
        }
      })
    },
		feedback() {
      this.visible = true;
      this.form = {
        type: '',
        desc: '',
        img: '',
        imgUrl: '',
        contact: ''
      }
      this.$util.doSensorsTrack('FeedbackClk', {
          TriggerPage: this.$route.name == 'homepage' ? 'CreatorCenterHome' : 'Otherpage',
          CurrentOperatorId: this.uid || '',
          CurrentOperatorIdName: this.name || '',
      })
    },
    UploadedSuccess(val, index) {
      // console.log(this.imglist)
      if (index >= 0) {
        this.$set(this.imgList, index, {
          imgUrl: val.uploadSrc,
          img: val.src
        })
        return;
      }
      this.canUpload = false;
      this.imgList.push({
        imgUrl: val.uploadSrc,
        img: val.src
      })
      this.$refs.upload.picSrc= '';
      this.canUpload = true;
    },
	}
}
</script>

<style lang="scss" scoped>
.el-form .el-input, .el-form .el-textarea {
  max-width: 100%;
}
svg {
  margin: 0 auto;
}
.back-to-ceiling {
	position: fixed;
	z-index: 1;
	display: inline-block;
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #666;
	text-align: center;
	cursor: pointer;
	p {
		line-height: 1.2;
		font-size: 12px;
	}
	&:hover {
		opacity: 0.85;
	}
	.icon--backToTopArrow {
		fill: #bfc1c8;
		background: none;
		margin: 0 auto 4px;
	}
}
.img-wrap {
  position: relative;
  display: inline-block;
  overflow: hidden;
  .delete {
    position: absolute;
    top:0;
    left: 0;
    z-index: 1;
    width: 100%;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
    display: none;
    a {
      color: #fff;
    }
  }
  &:hover .delete {
    display: block;
  }
}
.success-desc {
  font-size: 12px;
  font-weight: 400;
  color: #B8B8B8;
  line-height: 17px;
}
.success-img-wrap {
  width: 63px;
  height: 63px;
  margin: 10px auto 0;
  font-size: 50px;
}
</style>
